var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 11.9587H4.08366C2.33366 11.9587 1.16699 11.0837 1.16699 9.04199V4.95866C1.16699 2.91699 2.33366 2.04199 4.08366 2.04199H9.91699C11.667 2.04199 12.8337 2.91699 12.8337 4.95866V9.04199C12.8337 11.0837 11.667 11.9587 9.91699 11.9587Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91634 5.25L8.09051 6.70833C7.48967 7.18667 6.50384 7.18667 5.90301 6.70833L4.08301 5.25",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.1e7bf2e8cbb190f4096d5dfbfd641cac.svg";
export { ForwardRef as ReactComponent };